import queryString from 'query-string';
import fetchWithAuth from 'store/_helpers/fetchWithAuth';
import dataUriToBlob from './dataUriToBlob';

export default async function signUpload(themeId, endpoint, imageDataUri) {
  const { size, type } = dataUriToBlob(imageDataUri);
  const response = await fetchWithAuth(
    `/api/themes/${themeId}/${endpoint}?${queryString.stringify({ size, contentType: type })}`,
  );
  return response.json();
}
